package hk.com.vr360_demo2.webapp.core.ui_state

import kotlinx.serialization.Serializable

@Serializable
sealed class NetworkState{

   @Serializable
   data object Good: NetworkState()
   @Serializable
   data class Failed( val message:String? = null): NetworkState()

}
